import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { genericUnitField, ghgCategoryField } from './common/sharedFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { productFields, purchasedMaterialFields } from './common/productFields';
import { buildingCommonFields } from './common/buildingCommonFields';
import { msg } from '@lingui/core/macro';

export const directGhgEmissionsMetadata = {
  displayName: msg({
    message: 'Direct GHG emissions',
    context: 'Activity data schema name for direct GHG emissions',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    ...productFields,
    ...purchasedMaterialFields,
    ...buildingCommonFields,
    ghg_category_id: ghgCategoryField,
    gas_name: {
      displayName: msg({
        message: 'Gas name',
        context: 'The greenhouse gas name.',
      }),
      externalDescription: msg({
        message: 'The greenhouse gas name.',
        context: 'Gas name',
      }),
    },
    ghg_emission_reason: {
      displayName: msg({
        message: 'Emission reason',
        context: 'The reason for the emissions.',
      }),
      externalDescription: msg({
        message: 'The reason for the emission of the greenhouse gas.',
        context: 'Emissions reason',
      }),
    },
    process_description_method: {
      displayName: msg({
        message: 'Method used to measure emissions',
        context: 'The method used to measure the emissions.',
      }),
    },
    quantity: {
      displayName: msg({
        message: 'Direct greenhouse gas emissions',
        context:
          'The greenhouse gas emissions directly reported from input data.',
      }),
      externalDescription: msg({
        message:
          'The greenhouse gas emissions directly reported from input data.',
        context: 'Direct greenhouse gas emissions',
      }),
    },
    unit: genericUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
